<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent>
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="openMateEnterWrite">
              입고추가
            </el-button>
            <el-button type="danger" icon="el-icon-delete-solid" @click="deleteRow">
              입고삭제
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini" style="margin-left: -35px;">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="입고기간" label-width="120px">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker type="date" placeholder="Pick a date" v-model="form.startDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                  <el-col :span="1" style="text-align: center;">-</el-col>
                  <el-col :span="12">
                    <el-date-picker type="date" placeholder="Pick a date" v-model="form.endDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="제조사" label-width="120px">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8" style="margin-left:-40px;">
              <el-row>
                <el-form-item label="제품군" label-width="120px">
                  <el-col :span="10">
                    <el-select v-model="form.itemGroup" @change="onCatIdChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['itemGroup']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="10">
                    <el-select v-model="form.subItemGroup" v-show="changeCatIdShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subItemGroup']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>

          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="입고구분" label-width="120px">
                <el-select v-model="form.inType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['inType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="품번" label-width="120px">
                <el-input type="text" v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                enableRangeSelection="true"
                @cell-clicked="onCellClicked"
                @grid-ready="onReadyMain" />
          </div>

          <div class="grid-tbl-box" v-show="false">
            <ag-grid-vue
                ref="excelGrid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="excelColumnDefs"
                :grid-options="excelGridOptions"
                :row-data="excelData"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadyExcel"
            />
          </div>
        </div>
      </div>
    </div>


    <el-form size="mini" >
      <div>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="primary" style="float: right;" icon="el-icon-files" @click="updateCount()">
            수정
          </el-button>
        </el-form-item>
      </div>
    </el-form>

    <mate-Entering-Info ref="mateEnteringInfo" :mateEnteringDetail="mateEnteringDetail" style="height: 100%"/>
  </div>
</template>

<script>
import mixin from "@/mixin/lucoms";
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import MateEnteringInfo from '@/components/WorkMng/MateEnteringInfo.vue';
import MateEnterWrite from '@/components/LucomsModal/MateEnterWrite.vue';

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [mixin],
  props: {
  },
  components: {MateEnteringInfo},
  data() {
    return {
      data: [],
      excelData: [],
      form: {
        companyId : '',
        startDt: this.$moment().format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        inType : '',             // 입고구분
        maker : '',              // 제조사
        itemGroup : '',          // 제품군
        subItemGroup: '',        // 제품군 상세
        itemCd : '',             // 품번
        sortType : '',           // 승인/정산처리유형
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'maker' : [],
        'procYn' : [],
        'outType' : [],
        'subItemGroup' : []
      },
      changeCatIdShow : false,
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 10px; width: 100%;height: 550px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
        excelStyles: [
          { id: 'numberType',numberFormat: {format: '0',}},
          { id: 'stringType', dataType: 'String'},
          { id: 'dateType', dataType: 'DateTime'},
        ],
      },
      columnDefs: [],
      excelColumnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      mateEnteringDetail: []
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'입고일자', field:'inDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'입고구분', field:'inTypeNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'입고번호', field:'inItemId', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'제조사', field:'makerNm', width:140, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroupNm', width:110, cellStyle:{textAlign: 'left'}},
        {headerName:'품번', field:'itemCd', width:230},
        {headerName:'품명', field:'itemNm', width:400},
        {headerName:'수량', field:'goodQty', width:80, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return this.getNumberFormat(params.data.goodQty + params.data.recycleQty);
          },
        },
        {
          headerName: '선택',
          field: 'chk',
          width: 80,
          cellRenderer: 'checkBox',
          cellRendererParams: {
              trueValue: true    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: false  //false값 지정 defalut-"N" ex) "N", false, "0"
            , disable: false
          },
          //cellRenderer: 'checkboxRenderer'
        },
      ];
    },
    createExcelColumnDefs() {
      const that = this;
      this.excelColumnDefs = [
        {headerName:'입고일자', field:'inDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'입고구분', field:'inTypeNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'입고번호', field:'inItemId', width:120, cellStyle:{textAlign: 'center'}, cellClass: 'stringType'},
        {headerName:'제조사', field:'makerNm', width:140, cellStyle:{textAlign: 'center'}, cellClass: 'stringType'},
        {headerName:'제품군', field:'itemGroupNm', width:110, cellStyle:{textAlign: 'left'}, cellClass: 'stringType'},
        {headerName:'품번', field:'itemCd', width:230, cellClass: 'stringType'},
        {headerName:'품명', field:'itemNm', width:400, cellClass: 'stringType'},
        {headerName:'규격', field:'itemSpec', width:400, cellClass: 'stringType'},
        {headerName:'이평단가', field:'unitPrice1', width:400,
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }},
        {headerName:'수량', field:'goodQty', width:80, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return this.getNumberFormat(params.data.goodQty + params.data.recycleQty);
          },
        },
        {headerName:'이평금액', field:'unitPrice1Amt', width:400,
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }},
      ];
    },
    // onSelectionChangedSub(event) {
    //   this.gridApiSub = this.mainGridOptions.api;
    //   const voRow = this.gridApiSub.getSelectedRows() //선택된 Row
    //   this.mateEnteringDetail = []; // 초기화
    //   this.mateEnteringDetail = voRow[0];
    // },
    onCellClicked(params) {
      this.mateEnteringDetail = []; // 초기화
      this.mateEnteringDetail = params.data;
    },
    goOpen() {
      let that = this
      this.$store.commit('loading')
      const vForm = {
        companyId : this.form.companyId,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        inType : this.form.inType,             // 입고구분
        maker : this.form.maker,              // 제조사
        itemGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,          // 제품군
        subItemGroup: '',          // 제품군 상세
        itemCd : this.form.itemCd,             // 품번
        sortType : this.form.sortType,           // 승인/정산처리유형
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/workMng/mateEntering/list"), vForm)
          .then(response => {
            this.data = response.data
          }).finally(() => {
            this.$refs.mateEnteringInfo.dataClear();
            this.$store.commit('finish')
      });
    },
    updateCount(){
      if(!this.$refs.mateEnteringInfo.validation()) return;

      this.$swal({
        type: 'info',
        text: `입고 수량을 수정 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          const mateEnteringInfo = JSON.parse(JSON.stringify(this.$refs.mateEnteringInfo.form));

          this.$http.get(`/api/asMng/call/config`, {params: {keyPath: 'System.MainAsAgentId'}})
              .then(response => {
                mateEnteringInfo.asAgentId = response.data[0].configValue
                this.$http.post(`/api/workMng/mateEntering/update`, mateEnteringInfo).then((response) => {
                  this.$swal({type: 'info', text: '저장되었습니다.'});
                  this.goOpen();
                }).catch((e) => {
                  this.$swal({type: 'error', text: e.response.data.message});
                });

              });
        }
      });
    },
    deleteRow() {
      let vm = this;
      let list = this.data.filter(v => v.chk)
      vm.result = [];
      
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 삭제 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            vm.result = list;
            this.$http.post(_url(`/api/workMng/mateEntering/delete`), vm.result)
                .then((response) => {
                  this.$swal({ type: 'success', text: '입고 삭제를 하였습니다.' })
                      .then((result) => {
                        if (result.value) {
                          this.goOpen();
                        }
                      });
                })
                .catch((e) => {
                  this.$swal({ type: 'success', text: '입고 삭제를 실패 하였습니다.' })
                })
                .finally(() => {
                  this.$store.commit('finish')
                });
          }
        })
      } else {
        this.$swal({ type: 'info', text: '삭제할 항목을 선택하세요.' });
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/mateEntering/init`)
          .then(response => {
            this.combos['maker'] = response.data.maker;
            this.combos['itemGroup'] = response.data.itemGroup;
            this.combos['inType'] = response.data.inType;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
      this.createExcelColumnDefs();
    },
    onCatIdChange(param){
      this.form.subItemGroup = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subItemGroup'] = response.data || []
                  });
            });
      }
    },
    /**
     * 입고추가 팝업 오픈
     */
    openMateEnterWrite() {
      const vm = this

      this.$modal.open({
        component: MateEnterWrite,
        parent: this,
        props: {
        },
        events: {
          close(data) {
          },
        }
      });
    },
    excelDown(){
      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/mateEntering/getExcelList"), this.form)
          .then(response => {
            this.excelData = response.data.map(x => {
              x.unitPrice1Amt = x.unitPrice1 *  x.goodQty
              x.inDt = x.inDt !==null ? this.$moment(x.inDt).format('YYYY-MM-DD') : ''
              return x
            });
            console.log('this.excelData', this.excelData)

          }).finally(() => {
        this.$store.commit('finish');
        var params = {
          fileName : "자재입고처리"
        };
        this.excelGridOptions.api.exportDataAsExcel(params);

      });
    }
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>